export default __webpack_public_path__ + "static/media/etb-logo-white.f8e7e856.svg";